import type { ClikArtCategory, ClikArtItem } from '@/api/types/clikart'

/**
 * /clikart/categories and /clikart/search both group items by category
 * (`ClikArtCategory.artList`) — the gallery only needs one flat list (Category selection is
 * applied as a separate client-side filter, see `filterClikArtByCategory`).
 */
export function flattenClikArtCategories(categories: ClikArtCategory[]): ClikArtItem[] {
  return categories.flatMap((category) => category.artList)
}
